// extracted by mini-css-extract-plugin
module.exports = {"coBrandedLogo":"CoBrandingV2_coBrandedLogo__2VU9X","coBrandedName":"CoBrandingV2_coBrandedName__34gn1"};